import {User} from './user';
import {useCallback, useContext} from 'react';
import {SiteConfigContext} from '../core/settings/site-config-context';
import {useBootstrapData} from '../core/bootstrap-data/bootstrap-data-context';

interface UseAuthReturn {
    user: User | null;

    isLoggedIn: boolean;
    getRedirectUri: () => string;
}
export function useAuth(): UseAuthReturn {
    const {
        data: {user},
    } = useBootstrapData();
    const {
        auth: {redirectUri = '/'},
    } = useContext(SiteConfigContext);

    const getRedirectUri = useCallback(() => {
        // const staff = 5;

        // if (user?.role == 'admin') {
        //     return `/admin`;
        // } else return `/`;

        return '/admin';

        return redirectUri;
    }, [redirectUri]);

    return {
        user,
        isLoggedIn: !!user,
        // where to redirect user after successful login
        getRedirectUri,
    };
}
